(function (factory) {
    var undef;
    var root = typeof window !== undef ? window : typeof global !== undef ? global : this;
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function () {
            return factory(root);
        });
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(root);
    } else{
        root.MessageServiceTopic=factory(root);
    }
})(function(root){
    var EVENT = "Events";
    var EMPTY = "";
    var eventOpts = {
        bubbles : false,
        cancelable : false
    };

    var doc = root.document;

    // Partial Map polyfill.
    // Note: This is only designed to work with strings and functions.
    //       More complex data-structures won't create useful keys (uses .toString).
    function FakeMap(){
        this.store={};
    }
    
    FakeMap.prototype = {
        get: function (key) {
            return this.store[(key||EMPTY).toString()];
        },
        set: function (key, value) {
            this.store[(key||EMPTY).toString()] = value;  
        },
        has: function (key) {
            return ((key||EMPTY).toString()) in this.store;
        },
        delete: function (key) {
            delete this.store[(key||EMPTY).toString()];
        },
        forEach: function (cb, scope) {
            var key;
            var store = this.store;
            for (key in store) {
                cb.call(scope||this,store[key], key, this);
            }
        }
    }

    // Use Map where available, otherwise FakeMap will do.
    var ConsumerMap = root.Map || FakeMap;

    function TopicHandler (scope, consumer, autoRemove, topics, name) {
        this.scope = scope;
        this.originalConsumer = consumer;
        this.name = name;
        // If the handler is a .one handler, use handleEventOnce.
        if (autoRemove) {
            this.handleEvent = this.handleEventOnce;
            this.topics = topics;
        }
    }

    TopicHandler.prototype = {
        handleEvent: function (e) {
            return this.originalConsumer.call(this.scope, e.data,e);
        },
        handleEventOnce: function (e) {
            removeTopicListener(this.scope, this.topics, this.name, this.originalConsumer);
            return this.originalConsumer.call(this.scope, e.data,e);
        }
    }

    // Use CustomEvent constructor when available, otherwise fallback to document.createEvent
    var createEvent = Topic.createEvent = typeof CustomEvent === 'function' ? function (eventKey, customKey) {
            var evt = new CustomEvent(eventKey, eventOpts);
            evt.originalType = customKey || eventKey
            return evt;
        } : function (eventKey, customKey) {
            var evt = doc.createEvent(EVENT);
            evt.initEvent(eventKey, eventOpts.bubbles, eventOpts.cancelable);
            evt.originalType = customKey || eventKey
            return evt;
        };

    /**
     * @memberOf Topic
     */
    function Topic (name, hub) {
        this.name = name;
        this.consumers = new ConsumerMap();
        this.consumerCount = 0;
        this.hub = hub;
    } 

    /**
     * @memberOf Topic
     */
    Topic.prototype.publish = function (msg, customName) {
        var evt = createEvent(this.name, customName);
        evt.data = msg;
        this.hub.dispatchEvent(evt);
    };
    /**
     * @memberOf Topic
     */
    Topic.prototype.addConsumer = function (scope, consumer, autoRemove, topics) {
        var id=consumer;
        var hub = this.hub;
        var queue=this.consumers.get(id);
        var handler = new TopicHandler(scope, consumer, autoRemove, topics, this.name);

        if(queue){
            this.removeConsumer(scope, consumer);
        } else {
            queue = [];
        }

        queue.push(handler);
        this.consumerCount++;
        this.consumers.set(id, queue);
        hub.addEventListener(this.name, handler, false, true);
    };
        

    Topic.prototype.removeConsumer = function (scope, consumer) {
        var id=consumer;
        var cons=this.consumers.get(id);
        var name=this.name;
        var con;

        if (cons) {
            var len=cons.length;
            var i=0;
            for(; i<len; i++){
                con=cons[i];
                if (con.originalConsumer === consumer && (!scope || con.scope === scope )) {
                    this.hub.removeEventListener(name, con, false, true);
                    cons.splice(i, 1);
                    if (!cons.length) {
                       this.consumers.delete(id);
                    }
                    this.consumerCount--;
                    break;
                }
            }
        }
    };

    Topic.prototype.removeAllConsumers = function () {
        var key;
        var consumers = this.consumers;
        var name = this.name;
        var queue;
        var i;
        var len;

        consumers.forEach(removeHelper, this);
        this.consumerCount = 0;
    };

    function removeHelper (queue, key, map) {
        var i = 0;
        var len = queue.length;
        var hub = this.hub;
        var name = this.name;

        for(; i < len; i++){
            hub.removeEventListener(name, queue[i], false, true);
        }
        map.delete(key);
    }


    function publishTopic (topic, msg, customName){
        return topic && topic.publish(msg, customName);
    }
    Topic.publishTopic = publishTopic;

    function addTopicListener (scope, hub, topics, topicName, callback, autoRemove) {
        if(!callback){
            throw new Error('message-service : no listener specified for topic : ' + topicName);
            return;
        }
        var topic = topics[topicName] || (topics[topicName] = new Topic(topicName, hub));
        topic.addConsumer(scope, callback, autoRemove, topics);
    }
    Topic.addTopicListener = addTopicListener;

    function removeTopicListener (scope, topics, topicName, callback) {
        var topic = topics[topicName];
        if(topic && callback) {
            topic.removeConsumer(scope, callback);
            if(topic.consumerCount <= 0){
                delete topics[topicName];
            }
        }
    };
    Topic.removeTopicListener = removeTopicListener;

    function removeAllTopicListeners (topics, topicName) {
        var topic = topics[topicName];
        if(topic){
            topic.removeAllConsumers();
            delete topics[topicName];
        }
    }
    Topic.removeAllTopicListeners = removeAllTopicListeners;

    return Topic;
});